import { RiNotification3Line } from 'react-icons/ri';
import type { JSX } from 'react';
import styles from './SimpleToast.module.css';
import type { SimpleToastProps } from './SimpleToast.types';

const SimpleToast = ({
  message,
  buttonText = '',
  fadeOut = false,
  onButtonClick = () => {},
}: SimpleToastProps & { fadeOut?: boolean }): JSX.Element => {
  return (
    <div className={`${styles.toast} ${fadeOut ? styles.fadeOut : ''}`}>
      <span className={styles.iconWrap} aria-hidden="true">
        <RiNotification3Line className={styles.icon} />
      </span>
      <div className={styles.body}>
        <p className={styles.message}>{message}</p>
        {buttonText ? (
          <button
            type="button"
            className={styles.button}
            onClick={onButtonClick}
          >
            {buttonText}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default SimpleToast;
